import React from "react";
import { Wallet } from "lucide-react";

interface GuestCreditBadgeProps {
  /**
   * Balance in JOD. The lookup itself lives in useGuestCredit, owned by the
   * booking flow -- see that hook for why it cannot live in here.
   *
   * Deliberately NOT printed. Anyone can type any phone number into step 1,
   * so naming the amount here would turn the storefront into a balance
   * lookup for other people's numbers. The figure is shown later, in the
   * payment breakdown, where the client needs it to decide whether to spend
   * it -- same person, but only after they have committed to a booking.
   */
  balance: number;
  loading?: boolean;
}

export const GuestCreditBadge: React.FC<GuestCreditBadgeProps> = ({
  balance,
  loading = false,
}) => {
  if (loading || balance <= 0) return null;

  return (
    <div
      data-testid="guest-credit-badge"
      className="flex items-center gap-2.5 rounded-[14px] bg-slate-50 px-3.5 py-2.5 text-xs text-slate-800 border border-slate-200/90 shadow-xs animate-in fade-in slide-in-from-top-1 duration-200"
    >
      <Wallet className="h-4 w-4 text-slate-600 shrink-0" />
      <div className="flex-1">
        <span className="font-semibold text-slate-800">
          Store balance available for this phone number
        </span>
        <span className="text-[11px] text-slate-500 block mt-0.5 font-medium">
          We&apos;ll put it toward this booking
        </span>
      </div>
    </div>
  );
};
